import { Component } from '@angular/core';

@Component({
  selector: 'app-orders',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class FailedComponent {
}
